export const commonActionTypes = {
   // GLOBAL MESSAGE TYPES
   SET_GLOBAL_MESSAGE: "SET_GLOBAL_MESSAGE",
};
